<template>
  <div class="newsPage">
    <div class="banner">
      <img src="../assets/News/banner.jpg" alt="">
    </div>
    <div class="newsContent">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(list,index) in typeList" :key='index' :label="list.typeName" :typeId="list.typeId" :name="'type'+ index">
          <div class="newsBox">
            <ul class="clearfix">
            	<li v-for="(item,index) in productData" :key='index' @click="getNewsDetails(item.infoId)">
                <img :src="item.infoPic" alt="">
                <p>{{item.infoTitle}}</p>
              </li>
            </ul>
            <el-pagination
             background
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>

        </el-tabs>
    </div>
  </div>
</template>

<script>
  import {getHttp} from '../../common/http'
  export default {
    name: 'News',
    data() {
      return {
        activeName:"type0",
        pageIndex: 1,
        pageSize: 6,
        productData: [],
        typeList:[],
        // typeId:0,
        total:0,
        index:0
      }
    },
    methods: {
      // 切换类型
       handleClick(tab, event) {
        this.index = tab.index - 0;
        this.pageIndex = 1;
        this.getInformation();
        this.getTypeNum();
       },
       // 切换页码
       handleCurrentChange(pageIndex) {
         this.pageIndex = pageIndex;
         this.getInformation();
       },
       // 获取资讯列表
       getInformation(){
         let _this = this;
         console.log(_this.typeId)
         let data = {
           pageIndex: _this.pageIndex,
           pageSize: _this.pageSize
         }
         getHttp(_this.constants.INTERFACE_LIST.getInformationTypeList).then((res) => {
           console.log(res);
           data.infoType = res[0].typeId;
           if(res && _this.index != undefined ){
            data.infoType = res[_this.index].typeId;
           }
           //获取万typeInfo
           getHttp(_this.constants.INTERFACE_LIST.getInformationList,data).then((res) => {
             this.productData = res;
           }, (e) => {
             _this.$message.error(e.message || '获取失败')
           })
         }, (e) => {
           _this.$message.error(e.message || '获取失败')
         })
       },
       // 获取类型列表
       getType(){
         let _this = this;
         getHttp(_this.constants.INTERFACE_LIST.getInformationTypeList).then((res) => {
           _this.typeList = res;
           _this.typeId = res[0].typeId;
           console.log(this.typeId)
         }, (e) => {
           _this.$message.error(e.message || '获取失败')
         })
       },
       // 获取某个类型下的总数
       getTypeNum(){
         let _this = this;
         let data ={
           typeId:_this.typeId
         };
         getHttp(_this.constants.INTERFACE_LIST.getTypeNum,data).then((res) => {
           _this.total = res;
         }, (e) => {
           _this.$message.error(e.message || '获取失败')
         })
       },
       getNewsDetails(id){
         let infoId = id;
         this.$router.push({
            name: '资讯详情',
            params:{
              infoId:infoId,
            }
         });
       }
    },
    mounted(){
      this.getType();
      this.getTypeNum();
      this.getInformation();
    }
  }
</script>

<style lang="less" scoped>
  @import "../css/News.less";
</style>



// WEBPACK FOOTER //
// src/pages/News.vue